// extracted by mini-css-extract-plugin
export default {"sort":"Sort_sort__P-K9K","sort_select":"Sort_sort_select__x+80G"};